// 门铃

export default [
  {
    path: '/doorbellIndex',
    name: 'doorbellIndex',
    component: () => import('@/views/doorbellSystem/index'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/doorbellMachineList',
    name: 'doorbellMachineList',
    component: ()=>import('@/views/doorbellSystem/deviceManage/machineList'),
    meta: {
      title: '机型管理'
    }
  },
  {
    path: '/doorbellAddModelPage',
    name: 'doorbellAddModelPage',
    meta: {
      title: '新增机型'
    },
    component: () => import('@/views/doorbellSystem/deviceManage/addModelPage')
  },{
    path: '/doorbellEditModelPage',
    name: 'doorbellEditModelPage',
    meta: {
      title: '编辑机型'
    },
    component: () => import('@/views/doorbellSystem/deviceManage/editModelPage')
  },{
    path: '/doorbellCheckModel',
    name: 'doorbellCheckModel',
    meta: {
      title: '查看机型'
    },
    component: () => import('@/views/doorbellSystem/deviceManage/checkModel')
  },
  {
    path: '/doorbellOtaManger',
    name: 'doorbellOtaManger',
    component: () => import('@/views/doorbellSystem/apply/otaManger'),
    meta: {
      title: 'OTA管理'
    }
  },{
    path: '/doorbellAppManager',
    name: 'doorbellAppManager',
    component: () => import('@/views/doorbellSystem/apply/appManager'),
    meta: {
      title: 'APP管理'
    }
  }
  ,{
    path: '/doorbellOtaUpdateAddPage',
    name: 'doorbellOtaUpdateAddPage',
    meta: {
      title: 'OTA新增'
    },
    component: () => import('@/views/doorbellSystem/apply/otaUpdateAddPage')
  },{
    path: '/doorbellOtaUpdateEditPage',
    name: 'doorbellOtaUpdateEditPage',
    meta: {
      title: 'OTA编辑'
    },
    component: () => import('@/views/doorbellSystem/apply/otaUpdateEditPage')
  },{
    path: '/doorbellAppUpdateAddPage',
    name: 'doorbellAppUpdateAddPage',
    meta: {
      title: 'App新增'
    },
    component: () => import('@/views/doorbellSystem/apply/appUpdateAddPage')
  },{
    path: '/doorbellAppUpdateEditPage',
    name: 'doorbellAppUpdateEditPage',
    meta: {
      title: 'App编辑'
    },
    component: () => import('@/views/doorbellSystem/apply/appUpdateEditPage')
  },{
    path: '/doorbellApkUpdateAddPage',
    name: 'doorbellApkUpdateAddPage',
    meta: {
      title: 'Apk新增'
    },
    component: () => import('@/views/doorbellSystem/apply/apkUpdateAddPage')
  },{
    path: '/doorbellApkUpdateEditPage',
    name: 'doorbellApkUpdateEditPage',
    meta: {
      title: 'Apk编辑'
    },
    component: () => import('@/views/doorbellSystem/apply/apkUpdateEditPage')
  },{
    path: '/doorbellApkManager',
    name: 'doorbellApkManager',
    meta: {
      title: 'APK管理'
    },
    component: () => import('@/views/doorbellSystem/apply/apkManager')
  }
  ,{
    path: '/doorbellOtaDownloadLogs',
    name: 'doorbellOtaDownloadLogs',
    component: () => import('@/views/doorbellSystem/apply/otaDownloadLogs'),
    meta: {
      title: 'OTA升级记录'
    }
  },{
    path: '/doorbellDeviceAppExclude',
    name: 'doorbellDeviceAppExclude',
    component: () => import('@/views/doorbellSystem/apply/deviceAppExclude'),
    meta: {
      title: 'APP黑名单'
    }
  },{
    path: '/doorbellDeviceInstruction',
    name: 'doorbellDeviceInstruction',
    component: () => import('@/views/doorbellSystem/deviceManage/deviceInstruction'),
    meta: {
      title: '设备指令'
    }
  },{
    path: '/doorbellImeiErrorLogList',
    name: 'doorbellImeiErrorLogList',
    component: () => import('@/views/doorbellSystem/deviceManage/imeiErrorLogList'),
    meta: {
      title: '设备日志'
    }
  },
  {
    path: '/doorbellDeviceList',
    name: 'doorbellDeviceList',
    meta: {
      title: '设备中心'
    },
    component: () => import('@/views/doorbellSystem/deviceManage/deviceList')
  },
  {
    path: '/doorbellUserList',
    name: 'doorbellUserList',
    component: () => import('@/views/doorbellSystem/appUser/doorbellUserList'),
    meta: {
      title: '用户管理'
    }
  },
  {
    path: '/doorbellUserLoginLog',
    name: 'doorbellUserLoginLog',
    component: () => import('@/views/doorbellSystem/appUser/doorbellUserLoginLog'),
    meta: {
      title: '用户登录日志'
    }
  },
  {
    path: '/doorbellUserMonthRegister',
    name: 'doorbellUserMonthRegister',
    component: () => import("@/views/doorbellSystem/bi/userMonthRegister"),
    meta: {
      title: '用户统计'
    }
  },
  {
    path: '/doorbellDeviceMonthRegister',
    name: 'doorbellDeviceMonthRegister',
    component: () => import("@/views/doorbellSystem/bi/deviceMonthRegister"),
    meta: {
      title: '设备统计'
    }
  },
  {
    path: '/doorbellFeedbackList',
    name: 'doorbellFeedbackList',
    component: () => import('@/views/doorbellSystem/feedback/maskFeedbackList'),
    meta: {
      title: '用户反馈'
    }
  },
  {
    path: '/doorbellChannelAppPage',
    name: 'doorbellChannelAppPage',
    component: () => import('@/views/doorbellSystem/deviceManage/ChannelAppPage'),
    meta: {
      title:'渠道APP管理'
    }
  },
  {
    path: '/doorbellChannelList',
    name: 'doorbellChannelList',
    component: () => import('@/views/doorbellSystem/deviceManage/channelList'),
    meta: {
      title: '渠道管理'
    }
  },
  {
    path: '/doorbellVirtualSnLicenseList',
    name: 'doorbellVirtualSnLicenseList',
    meta: {
      title: '授权许可'
    },
    component: () => import('@/views/doorbellSystem/deviceManage/virtualSnLicenseList'),
  }, {
    path: '/doorbellVirtualSnBatchList',
    name: 'doorbellVirtualSnBatchList',
    meta: {
      title: '授权批次'
    },
    component: () => import('@/views/doorbellSystem/deviceManage/virtualSnBatchList'),
  },
  {
    path: '/doorbellUserBindList',
    name: 'doorbellUserBindList',
    component: () => import('@/views/doorbellSystem/appUser/doorbellUserBindList'),
    meta: {
      title: '绑定用户管理'
    }
  },


]



// WEBPACK FOOTER //
// ./src/router/doorbellRouter.js